import React, { useState, useEffect, useRef, useCallback } from "react";
import { Navigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";

import { 
  Character,
} from "@dndModels";
import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import DandDButtonBox from "@dndComponents/DandDButtonBoxSimple";
import CharConnectUtilities from "@dndUtilities/char_connect_utilities";
import CharacterInput from "./CharacterInput";
import FlexBox from "@components/layout/FlexBox";
import LoadingBox from "@components/input/LoadingBox";
import CheckBox from "@components/input/CheckBox";

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

interface Props {
}

export default function CharactersInput({ }: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [archives, setArchives] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const load = useCallback(async () => {
    if (api.user) {
      if (api.user.my_characters.length === 0) {
        api.user.my_characters = await api.getPlayerObjects<Character>({ data_type: "character" });
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      });
    }
  }, [fetched, load]);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  if (!fetched || loading) {
    return (<LoadingBox />);
  }
  if (api.user) {
    return (
      <FlexBox direction="column">
        { api.user && 
          <FlexBox direction="row">
            <FlexBox>
              <CheckBox
                name="View Archives"
                value={archives}
                onChange={setArchives}
              />
            </FlexBox>
            <FlexBox>
              <DandDButtonBox name="Create Character" 
                disabled={ processing || !api.online } 
                onClick={ async () => {
                  if (api.user) {
                    setProcessing(true);
                    const new_char = new Character();
                    new_char.owner_id = api.user._id;
                    const res = await api.createObject("character", new_char);
                    if (res && res.body.id) {
                      api.user.my_characters.push(new_char);
                    } else {
                      console.log(res);
                    }
                    setProcessing(false);
                  }
                }}
              />
            </FlexBox>
            <FlexBox>
              <DandDButtonBox name="Create Sidekick" 
                disabled={ processing || !api.online }  
                onClick={ async () => {
                  if (api.user) {
                    setProcessing(true);
                    const new_char = new Character();
                    new_char.owner_id = api.user._id;
                    new_char.sidekick = true;
                    const res = await api.createObject("character", new_char);
                    if (res && res.body.id) {
                      api.user.my_characters.push(new_char);
                    } else {
                      console.log(res);
                    }
                    setProcessing(false);
                  }
                }}
              />
            </FlexBox>
          </FlexBox>
        }
        { !reloading && 
          <>
            <FlexBox>
              <Grid container spacing={0} direction="row">
                { api.user.my_characters.filter(o => o.archived === archives).map(char => {
                  return (
                    <Grid size={3} key={char._id}>
                      <CharacterInput
                        char={char} 
                        onUpdated={() => { setReloading(true); }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </FlexBox>
          </>
        }
      </FlexBox>
    ); 
  } else {
    return <></>;
  }
}
